import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/shouldRoundUnassignedEntries`;

export const ROUTE: RouteDefinition = `${baseRoute}/shouldRoundUnassignedEntries`;
